export enum LocalStorageKeys {
  token = 'TOKEN',
  language = 'LANGUAGE',
  emailVerificationSent = 'EMAIL_VERIFICATION_SENT',
  isAuthenticatedWithEmail = 'IS_AUTH_WITH_EMAIL',
  uid = 'UID', // TODO check if it's secure?
  currentUser = 'CURRENT_USER',
  currentRole = 'CURRENT_ROLE',
  confirmedMail = 'CONFIRMED_MAIL',
  userMetadata = 'USER_METADATA',
  adminLectureTableFilter = 'ADMIN_LECTURE_TABLE_FILTER',
  adminUserTableFilter = 'ADMIN_USER_TABLE_FILTER',
  adminLecturesTableSelectedButton = 'ADMIN_LECTURE_TABLE_SELECTED_BUTTON',
  adminUserTableSelectedButton = 'ADMIN_USER_TABLE_SELECTED_BUTTON',
  auditTableFilter = 'AUDIT_TABLE_FILTER'
}
